import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetInsert85FullCaption() {
    return (<FullCaptionComponent title="VALUE: 85">
        <HashSetInsert851/>
        <HashSetInsert852/>
        <HashSetInsert853/>
        <HashSetInsert854/>
        <HashSetInsert855/>
    </FullCaptionComponent>)
}

export function HashSetInsert851() {
    return (<CaptionStepComponent
        title={<h6>1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
            unique. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>HashSets only contain unique <CodeComponent className="codeValue">VALUES</CodeComponent>. We should first
            call our <CodeComponent>contains</CodeComponent> function to make sure we don't already have an 85 in our
            HashSet. In this case, we do not already have 85, so we are good to continue.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert852() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>2. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Assuming our hash function is <CodeComponent>{generateHashFunction}</CodeComponent>, if we input 85, we
            output a <CodeComponent className="codeHash">HASH</CodeComponent> of 5.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert853() {
    return (<CaptionStepComponent title={<h6>3. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 5, we now want to find the
            sub-collection at index 5 of our array. Again, we see there is no collision to worry about, as there are no
            items located at index 5 yet.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert854() {
    return (<CaptionStepComponent
        title={<h6>4. Insert <CodeComponent className="codeValue">VALUE</CodeComponent> into the
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Next, we insert our <CodeComponent className="codeValue">VALUE</CodeComponent> of 85 into the sub-collection
            we found at index 5.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert855() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>5. If necessary, increase HashSet space to maintain an optimal
        balance. <CodeComponent>O(n)</CodeComponent></h6>}>
        <p>We now have filled 4 items in our HashSet, or 50% of our slots filled. To make sure we limit our chances of
            collisions, we want to increase the size of our HashSet by doubling the size of our Array. When we re-size
            our HashSet, we need to <CodeComponent className="codeHash">REHASH</CodeComponent> all of our <CodeComponent
                className="codeValue">VALUES</CodeComponent> to determine the new <CodeComponent
                className="codeHash">HASH</CodeComponent> indices for each <CodeComponent
                className="codeValue">VALUE</CodeComponent> in our set. In order to <CodeComponent
                className="codeHash">REHASH</CodeComponent>, we must repeat steps 1-4 for each of our <CodeComponent
                className="codeValue">VALUES</CodeComponent> we've already added to our HashSet. Even though steps 1-4
            are <CodeComponent>O(1)</CodeComponent> time complexity on their own, we will repeat the steps for the
            amount of items we have in our HashSet. If we have <CodeComponent>n</CodeComponent> items in our HashSet at
            the time we <CodeComponent className="codeHash">REHASH</CodeComponent>, this would make our time
            complexity <CodeComponent>O(n * 1)</CodeComponent> or, simplified, <CodeComponent>O(n)</CodeComponent>. Our
            hash function would remain the same, or <CodeComponent>{generateHashFunction}</CodeComponent>, so let's
            quickly run through what our new <CodeComponent className="codeHash">HASHES</CodeComponent> will be for each
            of our <CodeComponent className="codeValue">VALUES</CodeComponent>.</p>
        <ul>
            <li>87 % 16 = 7</li>
            <li>9 % 16 = 9</li>
            <li>-96 % 16 = 0</li>
            <li>85 % 16 = 5</li>
        </ul>
        <p>At this point, you just find the sub-collection at each of those <CodeComponent
            className="codeHash">HASH</CodeComponent> indexes, and insert the <CodeComponent
            className="codeValue">VALUES</CodeComponent> into the sub-collections found there.</p>
    </CaptionStepComponent>)
}
